'use strict';

var flatten = require('./flatten-a717674f.js');
var append = require('./append.js');
var flip = require('./flip.js');

/**
 * Returns a list that contains the elements in the list of `as` concatenated
 * with the starting value `s`.
 *
 * @private
 */

function concatWith(s, as) {
  return Array.from(flatten.flatten(as)).reduce(flip(append), s);
}

exports.concatWith = concatWith;
